module.exports = __webpack_public_path__ + "static/media/AO.02b12698.svg";